module.exports = __webpack_public_path__ + "media/images/application/template/30-second-quote/3x2-flatpack-75835a55e4eb7e805deaf54d0c4bd06d.png";